import * as yup from 'yup';

import { InvalidTypeValueError } from 'activate-errors';
import { NumberTypeBase } from '../../baseTypes/NumberTypeBase';
import { TypeContextEnum } from '../TypeContextEnum';
import { Types } from '../Types';
import { TYPE_GROUP_OTHER } from '../constants';

export class EmType extends NumberTypeBase {
  group = TYPE_GROUP_OTHER;

  name = 'Em';
  friendlyName = 'Em';
  contexts = [TypeContextEnum.Block];
  superUserOnly = true;

  get example() {
    return 5;
  }

  get default(): any {
    return 0;
  }

  buildSchema() {
    return yup.number().nullable();
  }

  deserialize = (value: any) => {
    if (value === undefined || value === null) {
      return value;
    }

    if (typeof value === 'number') {
      return value;
    }

    if (typeof value === 'string') {
      return Number.parseFloat(value);
    }

    throw new InvalidTypeValueError(`${value} for Em is not valid.`);
  };

  parseValue = (value: any) => `${value}em`;
}

const definition = new EmType();

Types.addBaseType(definition);
export { definition as EmDefinition };
